<template>
  <Promotion />
</template>

<script lang="ts">
  import { useSeoMeta, definePageMeta, useHead, useRuntimeConfig } from '#imports'
  import { defineNuxtComponent } from '#app'
  import Promotion from '@/components/Pokemon/LP/Promotion'
  
  export default defineNuxtComponent({
    components: {
      Promotion
    },
    async setup() {
      const { public: { APP_ENV } } = useRuntimeConfig()

      const title = '価格にはかいこうせん！！ポケカを安くさがすならカーナベル！ - カーナベル'
      const description = "価格にはかいこうせん！！ポケカを安くさがすならカーナベル！人気カードからコレクションまで、なんでもそろう「カーナベルデパート」で頼んだ翌日にGETだぜ！"
      useSeoMeta({
        title,
        description,
        ogTitle: title,
        ogDescription: description,
        robots: APP_ENV==='production' ? 'index,follow' :'noindex,nofollow',
        twitterSite: '@ka_nabell_pcg',
        ogSiteName: 'ポケカ販売ならカーナベル！',
        ogUrl: 'https://sell.ka-nabell.com/pokemon/lp/promotion/'
      })

      useHead({
        link: [
          {
            rel: 'canonical',
            href: 'https://sell.ka-nabell.com/pokemon/lp/promotion/'
          }
        ]
      })

      definePageMeta({
        genre: 'pokemon',
        layout: 'lp'
      })
    }
  })
</script>

<style scoped>
  h1 {
    border-bottom: 3px solid;
    border-image: linear-gradient(to right, #FFA6DC, #FFCC84, #FFED4A) 1;
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
</style>